import OembedPreviewComponent from './components/oembed_preview';
import store from '~/base_store';
import OembedModule from './store';
import { registerModule } from '~/services/store_service';
import { initializeComponents } from '~/utils/bundle_utils';

$(() => {
    store.registerModule('oembed', OembedModule);
    initializeComponents('#vue-oembed-media-link', OembedPreviewComponent, {
        onInit(component) {
            store.commit('oembed/updateUrl', component.value);

            $(document).on('click', '#js-add-campaign-btn', function(e){
                store.commit('oembed/resetVideoData');
                store.commit('oembed/updateUrl', null);
            });

            $(document).on('click', '.js-edit-auto-campaign-name-btn', function(e){
                const url = $(this).attr('data-auto-campaign-video-link');
                store.commit('oembed/updateUrl', url);
                if (url) {
                    store.dispatch('oembed/getVideo', {url: url});
                }
            });
        }
    });
});